import { useState } from 'react';
export var useHeaderMenu = function () {
    var _a = useState(0), parentPositionY = _a[0], setParentPositionY = _a[1];
    var updateParentPositionY = function (y) {
        setParentPositionY(y);
    };
    return { parentPositionY: parentPositionY, updateParentPositionY: updateParentPositionY };
};
useHeaderMenu.displayName = 'useHeaderMenu';
